import {useEffect, useRef, useState} from "react";
import {
  Card,
  Table,
  Stack,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  Box,
  Avatar,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import * as XLSX from "xlsx";
import Page from "src/components/Page";
import Scrollbar from "src/components/Scrollbar";
import SearchNotFound from "src/components/SearchNotFound";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import MyPagination from "src/components/common/MyPagination";
import {asyncRequest} from "src/services/network";
import {alert} from "src/services/alert";
import UserInfo from "src/components/common/UserInfo";
import UserInfoDrawer from "src/components/common/UserInfoDrawer";
import MoreMenu from "src/components/common/MoreMenu";
import {IMG_BASE_URL} from "src/config/constants";
import personOutline from "@iconify/icons-eva/person-outline";

const TABLE_HEAD = [
  {id: "id", label: "ID", alignRight: false, width: 120},
  {id: "mainUser", label: "鲸世优选用户", alignRight: false, width: 150},
  {id: "inviter", label: "金银通上级", alignRight: false, width: 150},
  {id: "grade", label: "职级", alignRight: false, width: 100},
  {id: "assets", label: "资产", alignRight: false, width: 300},
  {id: "auto_release", label: "自动释放", alignRight: false, width: 80},
  {id: "release_rate", label: "释放速率", alignRight: false, width: 110},
  {id: "action", label: "操作", alignRight: true, width: 80},
];

const SORT_OPTIONS = [
  {value: "income", label: "产出金豆"},
  {value: "coin_recharge", label: "充值赠送金豆"},
  {value: "equity_value", label: "现存权益值"},
  {value: "equity_value_total", label: "累计权益值"},
  {value: "frozen_equity_value", label: "冻结权益值"},
  {value: "score", label: "银豆"},
  {value: "direct_value", label: "有效直推业绩"},
  {value: "direct_value_total", label: "累计直推业绩"},
  {value: "frozen_direct_value", label: "冻结直推业绩"},
  {value: "release_rate", label: "释放速率"},
  {value: "income_total", label: "累积产出"},
  {value: "id", label: "金银通ID"},
];

const ORDER_OPTIONS = [
  {value: "desc", label: "倒序"},
  {value: "asc", label: "正序"},
];

const AUTO_RELEASE_OPTIONS = [
  {value: "", label: "全部"},
  {value: 1, label: "已开启"},
  {value: 0, label: "已关闭"},
];

const GRADE_OPTIONS = [
  {value: "", label: "全部"},
  {value: "junior", label: "主管"},
  {value: "middle", label: "经理"},
  {value: "senior", label: "总监"},
];

const GRADE_NAME_MAP = {
  'junior': '主管',
  'middle': '经理',
  'senior': '总监',
};

const moreMenus = [
  {title: "资产调整", icon: personOutline},
  {title: "释放设置", icon: personOutline},
  {title: "修改直推", icon: personOutline},
  {title: "直推业绩 - 冻结转可用", icon: personOutline},
  {title: "权益值 - 冻结转可用", icon: personOutline},
];

const ADJUST_ASSET_OPTIONS = [
  {value: "score", label: "银豆"},
  {value: "coinRecharge", label: "充值赠送金豆"},
  {value: "equityValue", label: "现存权益值"},
  {value: "frozenDirectValue", label: "冻结直推业绩"},
  {value: "frozenEquityValue", label: "冻结权益值"},
];

export default function JytUserList() {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [targetInviter, setTargetInviter] = useState(null);

  // 冻结转可用弹框状态
  const [unfreezeDialog, setUnfreezeDialog] = useState({open: false, row: null});
  const [unfreezeAmount, setUnfreezeAmount] = useState("");
  const [unfreezePassword, setUnfreezePassword] = useState("");
  const [unfreezeLoading, setUnfreezeLoading] = useState(false);

  // 权益值冻结转可用弹框状态
  const [unfreezeEquityDialog, setUnfreezeEquityDialog] = useState({open: false, row: null});
  const [unfreezeEquityAmount, setUnfreezeEquityAmount] = useState("");
  const [unfreezeEquityPassword, setUnfreezeEquityPassword] = useState("");
  const [unfreezeEquityLoading, setUnfreezeEquityLoading] = useState(false);

  // 资产调整弹框状态
  const [adjustDialog, setAdjustDialog] = useState({open: false, row: null});
  const [adjustFields, setAdjustFields] = useState("");
  const [adjustOperation, setAdjustOperation] = useState("add");
  const [adjustAmount, setAdjustAmount] = useState("");
  const [adjustPwd, setAdjustPwd] = useState("");
  const [adjustRemark, setAdjustRemark] = useState("");
  const [adjustLoading, setAdjustLoading] = useState(false);

  // 释放设置弹框状态
  const [releaseDialog, setReleaseDialog] = useState({open: false, row: null});
  const [releaseAuto, setReleaseAuto] = useState(0);
  const [releaseRate, setReleaseRate] = useState("");
  const [releasePwd, setReleasePwd] = useState("");
  const [releaseRemark, setReleaseRemark] = useState("");
  const [releaseLoading, setReleaseLoading] = useState(false);

  // 修改直推弹框状态
  const [inviterDialog, setInviterDialog] = useState({open: false, row: null});
  const [inviterId, setInviterId] = useState("");
  const [inviterPwd, setInviterPwd] = useState("");
  const [inviterLoading, setInviterLoading] = useState(false);

  // 批量拨付金豆弹框状态
  const [batchDialog, setBatchDialog] = useState(false);
  const [batchItems, setBatchItems] = useState([]);
  const [batchPwd, setBatchPwd] = useState("");
  const [batchLoading, setBatchLoading] = useState(false);
  const [batchOldDeadline, setBatchOldDeadline] = useState("");
  const [batchOldAmount, setBatchOldAmount] = useState("");
  const uploadRef = useRef(null);

  const [filter, setFilter] = useState({
    page: 0,
    size: 20,
    search: "",
    platId: "",
    mobile: "",
    autoRelease: "",
    gradeCode: "",
    sort: "income",
    order: "desc",
  });

  useEffect(() => {
    getItems();
  }, [filter]);

  async function getItems() {
    const {data, count} = await asyncRequest({
      path: "/jingxi/jyt-user/list",
      data: filter,
    });
    setItems(data || []);
    setTotal(count);
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({...filter, page: 0, size: newSize});
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({...filter, page: newPage});
  };

  function handleFilterChange(ki, val) {
    setFilter({...filter, [ki]: val});
  }

  function handleReset() {
    setFilter({
      page: 0,
      size: 20,
      search: "",
      platId: "",
      mobile: "",
      autoRelease: "",
      gradeCode: "",
      sort: "income",
      order: "desc",
    });
  }

  async function handleReleaseSetting() {
    if (!releasePwd) { alert("请输入超管密码", "error"); return; }
    const rate = parseFloat(releaseRate);
    if (releaseRate && (isNaN(rate) || rate < 0.01 || rate > 10)) {
      alert("释放速率必须在0.01到10之间", "error"); return;
    }
    setReleaseLoading(true);
    try {
      const data = {id: releaseDialog.row.id, password: releasePwd, remark: releaseRemark};
      if (releaseRate !== "") data.releaseRate = rate;
      data.auto_release = releaseAuto;
      const result = await asyncRequest({
        path: "/jingxi/jyt-user/update-release-setting",
        data,
      });
      if (result) {
        const item = items.find((it) => it.id === releaseDialog.row.id);
        if (item) {
          if (result.data.auto_release !== undefined) item.auto_release = result.data.auto_release;
          if (result.data.release_rate !== undefined) item.release_rate = result.data.release_rate;
          setItems([...items]);
        }
        alert(result.msg || "释放设置已更新", "success");
        setReleaseDialog({open: false, row: null});
        getItems();
      }
    } catch (e) { if (e) alert(e.message || "操作失败", "error"); }
    finally { setReleaseLoading(false); }
  }

  function handleMoreClick(type, row) {
    if (type === "资产调整") {
      setAdjustDialog({open: true, row});
      setAdjustFields("");
      setAdjustOperation("add");
      setAdjustAmount("");
      setAdjustPwd("");
      setAdjustRemark("");
      return;
    }
    if (type === "释放设置") {
      setReleaseDialog({open: true, row});
      setReleaseAuto(row.auto_release || 0);
      setReleaseRate(row.release_rate != null ? String(row.release_rate) : "");
      setReleasePwd("");
      setReleaseRemark("");
      return;
    }
    if (type === "修改直推") {
      setInviterDialog({open: true, row});
      setInviterId(row.inviter_id || "");
      setInviterPwd("");
      return;
    }
    if (type === "直推业绩 - 冻结转可用") {
      setUnfreezeDialog({open: true, row});
      setUnfreezeAmount("");
      setUnfreezePassword("");
      return;
    }
    if (type === "权益值 - 冻结转可用") {
      setUnfreezeEquityDialog({open: true, row});
      setUnfreezeEquityAmount("");
      setUnfreezeEquityPassword("");
      return;
    }
    alert(`${type}功能开发中`, "info");
  }

  async function handleUnfreezeDirectValue() {
    const amt = parseFloat(unfreezeAmount);
    if (!amt || amt <= 0) {
      alert("转换额度必须大于0", "error");
      return;
    }
    if (!unfreezePassword) {
      alert("请输入超管密码", "error");
      return;
    }
    const frozen = Number(unfreezeDialog.row?.frozen_direct_value) || 0;
    if (frozen < amt) {
      alert(`冻结直推业绩不足，当前冻结: ${frozen}`, "error");
      return;
    }
    setUnfreezeLoading(true);
    try {
      const result = await asyncRequest({
        path: "/jingxi/jyt-user/unfreeze-direct-value",
        data: {
          id: unfreezeDialog.row.id,
          amount: amt,
          password: unfreezePassword,
        },
      });
      if (result) {
        alert(result.msg || "操作成功", "success");
        setUnfreezeDialog({open: false, row: null});
        getItems();
      }
    } catch (e) {
      // asyncRequest code!==1 时已自动 alert，此处仅处理网络异常
      if (e) alert(e.message || "操作失败", "error");
    } finally {
      setUnfreezeLoading(false);
    }
  }

  async function handleUnfreezeEquityValue() {
    const amt = parseFloat(unfreezeEquityAmount);
    if (!amt || amt <= 0) {
      alert("转换额度必须大于0", "error");
      return;
    }
    if (!unfreezeEquityPassword) {
      alert("请输入超管密码", "error");
      return;
    }
    const frozen = Number(unfreezeEquityDialog.row?.frozen_equity_value) || 0;
    if (frozen < amt) {
      alert(`冻结权益值不足，当前冻结: ${frozen}`, "error");
      return;
    }
    setUnfreezeEquityLoading(true);
    try {
      const result = await asyncRequest({
        path: "/jingxi/jyt-user/unfreeze-equity-value",
        data: {
          id: unfreezeEquityDialog.row.id,
          amount: amt,
          password: unfreezeEquityPassword,
        },
      });
      if (result) {
        alert(result.msg || "操作成功", "success");
        setUnfreezeEquityDialog({open: false, row: null});
        getItems();
      }
    } catch (e) {
      if (e) alert(e.message || "操作失败", "error");
    } finally {
      setUnfreezeEquityLoading(false);
    }
  }

  async function handleAdjustAssets() {
    if (!adjustFields) { alert("请选择调整项目", "error"); return; }
    const amt = parseInt(adjustAmount, 10);
    if (!amt || amt <= 0) { alert("数量必须为正整数", "error"); return; }
    if (!adjustPwd) { alert("请输入超管密码", "error"); return; }
    setAdjustLoading(true);
    try {
      const result = await asyncRequest({
        path: "/jingxi/jyt-user/adjust-assets",
        data: {id: adjustDialog.row.id, field: adjustFields, operation: adjustOperation, amount: amt, password: adjustPwd, remark: adjustRemark},
      });
      if (result) { alert(result.msg || "操作成功", "success"); setAdjustDialog({open: false, row: null}); getItems(); }
    } catch (e) { if (e) alert(e.message || "操作失败", "error"); }
    finally { setAdjustLoading(false); }
  }

  async function handleUpdateInviter() {
    if (!inviterId && inviterId !== 0) { alert("请输入直推上级ID", "error"); return; }
    if (!inviterPwd) { alert("请输入超管密码", "error"); return; }
    setInviterLoading(true);
    try {
      const result = await asyncRequest({
        path: "/jingxi/jyt-user/update-inviter",
        data: {id: inviterDialog.row.id, inviterId: inviterId || null, password: inviterPwd},
      });
      if (result) { alert(result.msg || "操作成功", "success"); setInviterDialog({open: false, row: null}); getItems(); }
    } catch (e) { if (e) alert(e.message || "操作失败", "error"); }
    finally { setInviterLoading(false); }
  }

  function handleBatchUpload(e) {
    if (!e.target.files[0]) return;
    const reader = new FileReader();
    reader.onload = (event) => {
      if (uploadRef.current) uploadRef.current.value = null;
      try {
        const {result} = event.target;
        const workbook = XLSX.read(result, {type: "binary"});
        const items = [];
        for (const sheet in workbook.Sheets) {
          // sheet_to_json 默认第一行为列头，不解析为数据行
          const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheet], {defval: ""});
          for (const row of sheetData) {
            // 按列头名称解析：第一列=鲸世优选UID，第二列=金豆数量，第三列=备注
            const keys = Object.keys(row);
            if (keys.length < 2) continue;
            const uid = String(row[keys[0]] || "").trim();
            const amount = Number(row[keys[1]]);
            const remark = keys[2] ? String(row[keys[2]] || "").trim() : "";
            if (!uid || isNaN(amount) || amount === 0) continue;
            items.push({uid, amount, remark: remark || "批量拨付金豆"});
          }
          break; // 只读取第一个 sheet
        }
        setBatchItems(items);
      } catch (err) {
        console.error(err);
        alert("Excel文件解析失败，请检查格式", "error");
      }
    };
    reader.readAsBinaryString(e.target.files[0]);
  }

  async function handleBatchCoinRecharge() {
    if (batchItems.length === 0) { alert("请先上传Excel文件", "error"); return; }
    if (!batchPwd) { alert("请输入超管密码", "error"); return; }
    setBatchLoading(true);
    try {
      const data = {items: batchItems, password: batchPwd};
      if (batchOldDeadline && batchOldAmount) {
        data.oldUserDeadline = batchOldDeadline;
        data.oldUserAmount = Number(batchOldAmount);
      }
      const result = await asyncRequest({
        path: "/jingxi/jyt-user/batch-coin-recharge",
        data,
      });
      if (result) {
        alert(result.msg || "操作成功", "success");
        setBatchDialog(false);
        setBatchItems([]);
        setBatchPwd("");
        setBatchOldDeadline("");
        setBatchOldAmount("");
        getItems();
      }
    } catch (e) {
      if (e) alert(e.message || "操作失败", "error");
    } finally {
      setBatchLoading(false);
    }
  }

  const isNotFound = items.length === 0;

  return (
    <Page title="金银通用户管理">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            金银通用户管理
          </Typography>
        </Stack>

        <Card>
          <ListToolbar
            filterName={filter.search}
            onFilterName={(e) => handleFilterChange("search", e.target.value)}
            onRefresh={getItems}
            onReset={handleReset}
          >
            <Grid container spacing={1} alignItems="center">
              <Grid item>
                <TextField
                  size="small"
                  style={{width: 180}}
                  label="鲸世优选UID"
                  placeholder="鲸世优选UID"
                  autoComplete="off"
                  value={filter.platId}
                  onChange={(e) => handleFilterChange("platId", e.target.value)}
                />
              </Grid>
              <Grid item>
                <TextField
                  size="small"
                  style={{width: 160}}
                  label="手机号"
                  placeholder="手机号"
                  autoComplete="off"
                  value={filter.mobile}
                  onChange={(e) => setFilter({...filter, mobile: e.target.value, page: 0})}
                />
              </Grid>
              <Grid item>
                <FormControl size="small" style={{minWidth: 130}}>
                  <InputLabel>自动释放</InputLabel>
                  <Select
                    label="自动释放"
                    value={filter.autoRelease}
                    onChange={(e) => setFilter({...filter, autoRelease: e.target.value, page: 0})}
                  >
                    {AUTO_RELEASE_OPTIONS.map((opt) => (
                      <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item>
                <FormControl size="small" style={{minWidth: 130}}>
                  <InputLabel>职级</InputLabel>
                  <Select
                    label="职级"
                    value={filter.gradeCode}
                    onChange={(e) => setFilter({...filter, gradeCode: e.target.value, page: 0})}
                  >
                    {GRADE_OPTIONS.map((opt) => (
                      <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </ListToolbar>

          {/* 排序栏 + 批量操作 */}
          <Box sx={{px: 2, py: 1, borderBottom: 1, borderColor: "divider", backgroundColor: "#fafafa"}}>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Stack direction="row" alignItems="center" spacing={2}>
                <Typography variant="body2" sx={{fontWeight: "bold"}}>排序：</Typography>
                <FormControl size="small" sx={{minWidth: 140}}>
                  <InputLabel>排序项</InputLabel>
                  <Select
                    label="排序项"
                    value={filter.sort || "income"}
                    onChange={(e) => setFilter({...filter, sort: e.target.value, page: 0})}
                  >
                    {SORT_OPTIONS.map((option) => (
                      <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl size="small" sx={{minWidth: 100}}>
                  <InputLabel>排序方式</InputLabel>
                  <Select
                    label="排序方式"
                    value={filter.order || "desc"}
                    onChange={(e) => setFilter({...filter, order: e.target.value, page: 0})}
                  >
                    {ORDER_OPTIONS.map((option) => (
                      <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Stack>
              <Stack direction="row" alignItems="center" spacing={1}>
                <Typography variant="body2" sx={{fontWeight: "bold"}}>批量操作：</Typography>
                <Button variant="contained" size="small" onClick={() => { setBatchDialog(true); setBatchItems([]); setBatchPwd(""); }}>
                  批量拨付金豆
                </Button>
              </Stack>
            </Stack>
          </Box>

          <Scrollbar>
            <TableContainer sx={{minWidth: 1200}}>
              <Table>
                <ListHead headLabel={TABLE_HEAD}/>
                <TableBody>
                  {items.map((row) => {
                    const {
                      id,
                      plat_id,
                      user_nickname,
                      mobile,
                      income,
                      coin_recharge,
                      score,
                      equity_value,
                      equity_value_total,
                      frozen_equity_value,
                      direct_value,
                      direct_value_total,
                      frozen_direct_value,
                      auto_release,
                      release_rate,
                      grade_code,
                      grade_name,
                      mainUser,
                      inviter,
                    } = row;

                    return (
                      <TableRow hover key={id} tabIndex={-1}>
                        {/* ID列 */}
                        <TableCell align="left" sx={{width: 120}}>
                          <Stack>
                            <Typography variant="body2">金银通ID：{id}</Typography>
                            <Typography variant="caption" color="text.secondary">
                              UID：{plat_id || "-"}
                            </Typography>
                          </Stack>
                        </TableCell>
                        {/* 鲸世优选用户列 */}
                        <TableCell align="left" sx={{width: 150}}>
                          {mainUser ? (
                            <UserInfo
                              avatar={mainUser.avatar}
                              uid={mainUser.uid}
                              nickname={mainUser.nickname}
                              enablePreview
                            />
                          ) : (
                            <Stack>
                              <Typography variant="body2">{user_nickname || "-"}</Typography>
                              <Typography variant="caption" color="text.secondary">{mobile || "-"}</Typography>
                            </Stack>
                          )}
                        </TableCell>
                        {/* 金银通上级列 */}
                        <TableCell align="left" sx={{width: 150}}>
                          {inviter ? (
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={1}
                              sx={{cursor: "pointer"}}
                              onClick={() => {
                                if (inviter.plat_id) {
                                  setTargetInviter({
                                    uid: inviter.plat_id,
                                    avatar: inviter.avatar,
                                    nickname: inviter.user_nickname,
                                  });
                                }
                              }}
                            >
                              <Avatar
                                src={inviter.avatar && !inviter.avatar.startsWith('http') ? `${IMG_BASE_URL}${inviter.avatar}` : inviter.avatar}
                                sx={{width: 32, height: 32}}
                              />
                              <Stack>
                                <Typography variant="body2">{inviter.user_nickname || `ID:${inviter.id}`}</Typography>
                                <Typography variant="caption" color="text.secondary">
                                  UID: {inviter.plat_id || "-"}
                                </Typography>
                              </Stack>
                            </Stack>
                          ) : (
                            <Typography variant="body2" color="text.secondary">-</Typography>
                          )}
                        </TableCell>
                        {/* 职级列 */}
                        <TableCell align="left" sx={{width: 100}}>
                          <Stack direction="row" alignItems="center" spacing={0.5}>
                            <Box
                              sx={{
                                width: 8,
                                height: 8,
                                borderRadius: '50%',
                                backgroundColor: grade_code === 'senior' ? '#f44336' : grade_code === 'middle' ? '#ff9800' : grade_code === 'junior' ? '#2196f3' : '#9e9e9e',
                              }}
                            />
                            <Typography variant="body2" sx={{
                              color: grade_code === 'senior' ? '#f44336' : grade_code === 'middle' ? '#ff9800' : grade_code === 'junior' ? '#2196f3' : '#9e9e9e',
                              fontWeight: grade_code ? 'bold' : 'normal',
                            }}>
                              {grade_name || '未评级'}
                            </Typography>
                          </Stack>
                        </TableCell>
                        {/* 资产列 */}
                        <TableCell align="left" sx={{width: 300}}>
                          <Stack spacing={0.3}>
                            <Typography noWrap variant="body2">金豆(产出/充值和赠送)：{income || 0} / {coin_recharge || 0}</Typography>
                            <Typography noWrap variant="body2">银豆：{score || 0}</Typography>
                            <Typography noWrap variant="body2">权益值(现存/冻结/累计)：{equity_value || 0} / {frozen_equity_value || 0} / {equity_value_total || 0}</Typography>
                            <Typography noWrap variant="body2">直推业绩(有效/冻结/累计)：{direct_value || 0} / {frozen_direct_value || 0} / {direct_value_total || 0}</Typography>
                          </Stack>
                        </TableCell>
                        {/* 自动释放列 */}
                        <TableCell align="left" sx={{width: 80}}>
                          <Typography variant="body2" sx={{color: auto_release === 1 ? "success.main" : "text.disabled"}}>
                            {auto_release === 1 ? "开启" : "关闭"}
                          </Typography>
                        </TableCell>
                        {/* 释放速率列 */}
                        <TableCell align="left" sx={{width: 110}}>
                          <Typography variant="body2">{release_rate ?? 0}</Typography>
                        </TableCell>
                        {/* 操作列 */}
                        <TableCell align="right" sx={{width: 80}}>
                          <MoreMenu
                            spread={false}
                            menus={moreMenus}
                            onMoreClick={(type) => handleMoreClick(type, row)}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={7} sx={{py: 5}}>
                        <SearchNotFound searchQuery={filter.search}/>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange}/>
        </Card>
      </Container>

      {targetInviter && (
        <UserInfoDrawer
          open
          uid={targetInviter.uid}
          avatar={targetInviter.avatar}
          nickname={targetInviter.nickname}
          onClose={() => setTargetInviter(null)}
        />
      )}

      {/* 冻结转可用弹框 */}
      <Dialog open={unfreezeDialog.open} onClose={() => setUnfreezeDialog({open: false, row: null})} maxWidth="xs" fullWidth>
        <DialogTitle>直推业绩 - 冻结转可用</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{mt: 1}}>
            <Typography variant="body2">
              用户：{unfreezeDialog.row?.user_nickname || unfreezeDialog.row?.plat_id || `-`}
            </Typography>
            <Typography variant="body2">
              当前冻结直推业绩：{unfreezeDialog.row?.frozen_direct_value || 0}
            </Typography>
            <Typography variant="body2">
              当前可用直推业绩：{unfreezeDialog.row?.direct_value || 0}
            </Typography>
            <TextField
              label="转换额度"
              type="number"
              size="small"
              fullWidth
              inputProps={{step: 0.01, min: 0.01}}
              value={unfreezeAmount}
              onChange={(e) => setUnfreezeAmount(e.target.value)}
            />
            <TextField
              label="超管密码"
              type="password"
              size="small"
              fullWidth
              value={unfreezePassword}
              onChange={(e) => setUnfreezePassword(e.target.value)}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setUnfreezeDialog({open: false, row: null})}>取消</Button>
          <Button variant="contained" color="warning" onClick={handleUnfreezeDirectValue} disabled={unfreezeLoading}>
            {unfreezeLoading ? "处理中..." : "确认转换"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* 权益值冻结转可用弹框 */}
      <Dialog open={unfreezeEquityDialog.open} onClose={() => setUnfreezeEquityDialog({open: false, row: null})} maxWidth="xs" fullWidth>
        <DialogTitle>权益值 - 冻结转可用</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{mt: 1}}>
            <Typography variant="body2">
              用户：{unfreezeEquityDialog.row?.user_nickname || unfreezeEquityDialog.row?.plat_id || `-`}
            </Typography>
            <Typography variant="body2">
              当前冻结权益值：{unfreezeEquityDialog.row?.frozen_equity_value || 0}
            </Typography>
            <Typography variant="body2">
              当前可用权益值：{unfreezeEquityDialog.row?.equity_value || 0}
            </Typography>
            <TextField
              label="转换额度"
              type="number"
              size="small"
              fullWidth
              inputProps={{step: 0.01, min: 0.01}}
              value={unfreezeEquityAmount}
              onChange={(e) => setUnfreezeEquityAmount(e.target.value)}
            />
            <TextField
              label="超管密码"
              type="password"
              size="small"
              fullWidth
              value={unfreezeEquityPassword}
              onChange={(e) => setUnfreezeEquityPassword(e.target.value)}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setUnfreezeEquityDialog({open: false, row: null})}>取消</Button>
          <Button variant="contained" color="warning" onClick={handleUnfreezeEquityValue} disabled={unfreezeEquityLoading}>
            {unfreezeEquityLoading ? "处理中..." : "确认转换"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* 资产调整弹框 */}
      <Dialog open={adjustDialog.open} onClose={() => setAdjustDialog({open: false, row: null})} maxWidth="xs" fullWidth>
        <DialogTitle>资产调整</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{mt: 1}}>
            <Typography variant="body2">
              用户：{adjustDialog.row?.user_nickname || adjustDialog.row?.plat_id || `-`}
            </Typography>

            {/* 调整项目多选 */}
            <FormControl size="small" fullWidth>
              <InputLabel>调整项目</InputLabel>
              <Select
                label="调整项目"
                value={adjustFields}
                onChange={(e) => setAdjustFields(e.target.value)}
              >
                {ADJUST_ASSET_OPTIONS.map((opt) => (
                  <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* 操作类型 */}
            <Stack direction="row" spacing={2} alignItems="center">
              <Typography variant="body2" sx={{minWidth: 70}}>操作类型：</Typography>
              <Stack direction="row" spacing={1}>
                <Button
                  size="small"
                  variant={adjustOperation === "add" ? "contained" : "outlined"}
                  color="primary"
                  onClick={() => setAdjustOperation("add")}
                >增加</Button>
                <Button
                  size="small"
                  variant={adjustOperation === "subtract" ? "contained" : "outlined"}
                  color="error"
                  onClick={() => setAdjustOperation("subtract")}
                >减少</Button>
              </Stack>
            </Stack>

            <TextField
              label="数量（正整数）"
              type="number"
              size="small"
              fullWidth
              inputProps={{step: 1, min: 1}}
              value={adjustAmount}
              onChange={(e) => setAdjustAmount(e.target.value)}
            />
            <TextField
              label="超管密码"
              type="password"
              size="small"
              fullWidth
              value={adjustPwd}
              onChange={(e) => setAdjustPwd(e.target.value)}
            />
            <TextField
              label="备注"
              size="small"
              fullWidth
              multiline
              rows={2}
              value={adjustRemark}
              onChange={(e) => setAdjustRemark(e.target.value)}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAdjustDialog({open: false, row: null})}>取消</Button>
          <Button variant="contained" color="warning" onClick={handleAdjustAssets} disabled={adjustLoading}>
            {adjustLoading ? "处理中..." : "确认调整"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* 释放设置弹框 */}
      <Dialog open={releaseDialog.open} onClose={() => setReleaseDialog({open: false, row: null})} maxWidth="xs" fullWidth>
        <DialogTitle>释放设置</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{mt: 1}}>
            <Typography variant="body2">
              用户：{releaseDialog.row?.user_nickname || releaseDialog.row?.plat_id || `-`}
            </Typography>

            {/* 自动释放开关 */}
            <Stack direction="row" spacing={2} alignItems="center">
              <Typography variant="body2" sx={{minWidth: 70}}>自动释放：</Typography>
              <Stack direction="row" spacing={1}>
                <Button
                  size="small"
                  variant={releaseAuto === 1 ? "contained" : "outlined"}
                  color="success"
                  onClick={() => setReleaseAuto(1)}
                >开启</Button>
                <Button
                  size="small"
                  variant={releaseAuto === 0 ? "contained" : "outlined"}
                  color="error"
                  onClick={() => setReleaseAuto(0)}
                >关闭</Button>
              </Stack>
            </Stack>

            <TextField
              label="释放速率（0.01 ~ 10）"
              type="number"
              size="small"
              fullWidth
              inputProps={{step: 0.01, min: 0.01, max: 10}}
              value={releaseRate}
              onChange={(e) => setReleaseRate(e.target.value)}
            />
            <TextField
              label="超管密码"
              type="password"
              size="small"
              fullWidth
              value={releasePwd}
              onChange={(e) => setReleasePwd(e.target.value)}
            />
            <TextField
              label="备注"
              size="small"
              fullWidth
              multiline
              rows={2}
              value={releaseRemark}
              onChange={(e) => setReleaseRemark(e.target.value)}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setReleaseDialog({open: false, row: null})}>取消</Button>
          <Button variant="contained" color="warning" onClick={handleReleaseSetting} disabled={releaseLoading}>
            {releaseLoading ? "处理中..." : "确认修改"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* 修改直推弹框 */}
      <Dialog open={inviterDialog.open} onClose={() => setInviterDialog({open: false, row: null})} maxWidth="xs" fullWidth>
        <DialogTitle>修改直推上级</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{mt: 1}}>
            <Typography variant="body2">
              用户：{inviterDialog.row?.user_nickname || inviterDialog.row?.plat_id || `-`}
            </Typography>
            <Typography variant="body2">
              当前直推上级ID：{inviterDialog.row?.inviter_id || "无"}
            </Typography>
            <TextField
              label="新直推上级ID（金银通ID）"
              type="number"
              size="small"
              fullWidth
              value={inviterId}
              onChange={(e) => setInviterId(e.target.value)}
              helperText="输入0可清空直推上级"
            />
            <TextField
              label="超管密码"
              type="password"
              size="small"
              fullWidth
              value={inviterPwd}
              onChange={(e) => setInviterPwd(e.target.value)}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInviterDialog({open: false, row: null})}>取消</Button>
          <Button variant="contained" color="warning" onClick={handleUpdateInviter} disabled={inviterLoading}>
            {inviterLoading ? "处理中..." : "确认修改"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* 批量拨付金豆弹框 */}
      <Dialog open={batchDialog} onClose={() => setBatchDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>批量拨付金豆</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{mt: 1}}>
            <Typography variant="body2" color="text.secondary">
              Excel第一行为列头（不解析），数据从第二行开始。三列：鲸世优选UID、新用户金豆数量（正数加/负数扣，最多两位小数）、备注（可选）
            </Typography>
            <Button variant="outlined" component="label">
              选择Excel文件
              <input type="file" hidden accept=".xlsx,.xls" ref={uploadRef} onChange={handleBatchUpload} />
            </Button>
            {batchItems.length > 0 && (
              <>
                <Typography variant="body2" sx={{fontWeight: "bold"}}>
                  已解析 {batchItems.length} 条记录
                </Typography>
                <Box sx={{maxHeight: 200, overflow: 'auto', border: '1px solid #ddd', borderRadius: 1}}>
                  <Table size="small">
                    <TableBody>
                      {batchItems.slice(0, 20).map((item, idx) => (
                        <TableRow key={idx}>
                          <TableCell sx={{py: 0.3, px: 1}}>{item.uid}</TableCell>
                          <TableCell sx={{py: 0.3, px: 1, color: item.amount < 0 ? 'error.main' : 'success.main'}}>{item.amount}</TableCell>
                          <TableCell sx={{py: 0.3, px: 1}}>{item.remark}</TableCell>
                        </TableRow>
                      ))}
                      {batchItems.length > 20 && (
                        <TableRow>
                          <TableCell colSpan={3} align="center" sx={{py: 0.5, color: 'text.secondary'}}>
                            ...还有{batchItems.length - 20}条记录
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </Box>
              </>
            )}
            <Typography variant="body2" sx={{fontWeight: "bold", mt: 1}}>老用户设置（可选）</Typography>
            <Typography variant="body2" color="text.secondary">
              设置后，注册时间早于截止日期的用户视为老用户，按老用户金豆数量拨付；未设置则全部按Excel中金豆数量拨付
            </Typography>
            <Stack direction="row" spacing={2}>
              <TextField
                label="老用户截止日期"
                type="date"
                size="small"
                fullWidth
                value={batchOldDeadline}
                onChange={(e) => setBatchOldDeadline(e.target.value)}
                InputLabelProps={{shrink: true}}
              />
              <TextField
                label="老用户金豆数量"
                type="number"
                size="small"
                fullWidth
                value={batchOldAmount}
                onChange={(e) => setBatchOldAmount(e.target.value)}
                placeholder="如：100"
                inputProps={{step: "0.01"}}
              />
            </Stack>
            <TextField
              label="超管密码"
              type="password"
              size="small"
              fullWidth
              value={batchPwd}
              onChange={(e) => setBatchPwd(e.target.value)}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setBatchDialog(false)}>取消</Button>
          <Button variant="contained" color="warning" onClick={handleBatchCoinRecharge} disabled={batchLoading || batchItems.length === 0}>
            {batchLoading ? "处理中..." : `确认拨付（${batchItems.length}条）`}
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}
